module.exports = __webpack_public_path__ + "2af41f0f59849f7ff3bfe5ff05591393.pdf";